import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { levelFor } from "../lib/levels";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const MOODS = [
  { value: "radiant", label: "Radiant", emoji: "🌞" },
  { value: "okay", label: "Okay", emoji: "🪴" },
  { value: "meh", label: "Meh", emoji: "🌥️" },
  { value: "low", label: "Low", emoji: "🌧️" },
  { value: "stormy", label: "Stormy", emoji: "⛈️" },
];

export default function Mood() {
  const { user, setUser } = useAuth();
  const lvl = levelFor(user?.current_level || 1);
  const [picked, setPicked] = useState(null);
  const [note, setNote] = useState("");
  const [history, setHistory] = useState([]);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/mood/history");
      setHistory(data.items);
    } catch (err) {
      console.error("mood history load failed:", err);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (!picked) return;
    try {
      await api.post("/mood", { mood: picked, note });
      try { const { data } = await api.get("/auth/me"); setUser(data); } catch (err) { console.error("user refresh failed:", err); }
      toast.success("+10 XP · Empathy +1");
      setDone(true);
      setTimeout(() => nav("/dashboard"), 900);
    } catch { toast.error("Couldn't save your mood."); }
  };

  return (
    <div className="animate-fadeUp" data-testid="mood-page">
      <div className="text-xs font-bold uppercase tracking-[0.25em] opacity-60">Daily check-in</div>
      <h1 className="font-display font-black text-4xl tracking-tighter mt-2">How's your inner weather?</h1>

      <div className="mt-8 grid grid-cols-5 gap-3">
        {MOODS.map(m => (
          <button
            key={m.value}
            data-testid={`mood-${m.value}`}
            onClick={() => setPicked(m.value)}
            className={`btn-pill rounded-3xl p-5 border-2 text-center ${picked === m.value ? "border-[#0e203b] bg-[#0e203b] text-white" : "border-[#0e203b]/5 bg-white"}`}
          >
            <div className="text-4xl">{m.emoji}</div>
            <div className="mt-2 font-bold text-sm">{m.label}</div>
          </button>
        ))}
      </div>

      <textarea
        data-testid="mood-note"
        value={note}
        onChange={e => setNote(e.target.value)}
        rows={3}
        placeholder="Optional: a word about why."
        className="mt-6 w-full p-4 rounded-2xl border-2 border-[#0e203b]/10 focus:border-[#0e203b] outline-none font-medium bg-white resize-none"
      />
      <div className="flex justify-end mt-4">
        <button disabled={!picked || done} onClick={save} data-testid="mood-save" className="btn-pill bg-[#0e203b] text-white rounded-full px-7 h-12 font-bold disabled:opacity-40">
          {done ? "Saved" : "Log mood"}
        </button>
      </div>

      {history.length > 0 && (
        <div className="mt-10">
          <div className="font-display font-bold text-xl mb-3">Last 7 check-ins</div>
          <div className="flex gap-3 flex-wrap">
            {history.slice(0, 7).map(h => (
              <div key={h.id} className="bg-white rounded-2xl px-4 py-3 border border-[#0e203b]/5 text-sm" data-testid="mood-history-item">
                <div className="font-bold">{MOODS.find(m => m.value === h.mood)?.emoji} {h.mood}</div>
                <div className="text-xs opacity-60">{new Date(h.created_at).toLocaleDateString()}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
